import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { useLeadsNotSnoozedFilters } from "modules/LeadsDashboard/Leads/NotSnoozedLeads/hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { groupAndSortPaginatedItems } from "utils/paginatedItems";

export const useLeadsNotSnoozedQuery = () => {
  const notSnoozedFilters = useLeadsNotSnoozedFilters();

  const query = useTypedQuery({
    queryKey: LeadsQueryKeys.listNotSnoozed,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, notSnoozedFilters, baseUrl)).data,
    select: groupAndSortPaginatedItems,
    enabled: false
  });

  useEffect(() => {
    const hasDateRangeSelected = notSnoozedFilters.date_from && notSnoozedFilters.date_to;
    const hasDealerLocationSelected = notSnoozedFilters.location_ids.length > 0 || notSnoozedFilters.dealer_ids.length > 0;

    if (hasDealerLocationSelected && Boolean(hasDateRangeSelected)) query.refetch();
  }, [notSnoozedFilters]);

  return query;
};
